import { render, staticRenderFns } from "./UmsTokenViewer.vue?vue&type=template&id=0e67a31e&"
import script from "./UmsTokenViewer.vue?vue&type=script&lang=js&"
export * from "./UmsTokenViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports